import {
    GET_SKETCH_ORDERS_REQUEST,
    GET_SKETCH_ORDERS_SUCCESS,
    GET_SKETCH_ORDERS_FAILURE,
    GET_SKETCH_ORDER_SUCCESS,
    UPDATE_SKETCH_ORDER_SUCCESS,
    GET_SKETCH_ORDER_REQUEST,
    UPDATE_SKETCH_ORDER_REQUEST,
    GET_SKETCH_ORDER_FAILURE,
    UPDATE_SKETCH_ORDER_FAILURE
} from '../actions/actionTypes';
import mapKeys from 'lodash/mapKeys';

const initState = {
    isFetching: false,
    sketchOrders: {},
    ids: [],
    totalResults: 0,
    totalPages: 0,
    currentPage: 0,
};

const mapRequestedDate = (sketchOrders) => {
    if (!sketchOrders)
        return sketchOrders;

    return sketchOrders.map(s => {
        //map requesteddate -> requestedDate to keep things simple in the UI.  it depends on what endpoint in the
        //api as to how it comes back.

        if (!s.requestedDate && s.requesteddate) {
            s.requestedDate = s.requesteddate;
        }

        const now = new Date();
        const timeRequested = new Date(s.requestedDate);

        s.timeSinceRequested = Math.round((Math.abs(now - timeRequested) / 36e5) * 100) / 100;

        return s;
    });
};

const normalizeSketchOrders = (sketchOrders) => {
    const sketchOrdersWithMappedRequestedDate = mapRequestedDate(sketchOrders);

    return mapKeys(sketchOrdersWithMappedRequestedDate, 'id');
}

const sketchOrdersReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_SKETCH_ORDERS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SKETCH_ORDERS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                totalResults: action.response.totalResults,
                totalPages: action.response.totalPages,
                currentPage: action.response.page,
                sketchOrders: normalizeSketchOrders(action.response.resourceList),
                ids: action.response.resourceList.map(sketchOrder => sketchOrder.id),
            });
        case GET_SKETCH_ORDERS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                sketchOrders: {},
                ids: [],
                totalResults: 0,
                totalPages: 0,
                currentPage: 0
            });
        case GET_SKETCH_ORDER_REQUEST:
        case UPDATE_SKETCH_ORDER_REQUEST:
            return Object.assign({}, state, {
                sketchOrders: {
                    ...state.sketchOrders,
                    [action.params.id]: {
                        ...state.sketchOrders[action.params.id],
                        isFetching: true,
                    }
                }
            });
        case GET_SKETCH_ORDER_SUCCESS:
        case UPDATE_SKETCH_ORDER_SUCCESS:
            return Object.assign({}, state, {
                sketchOrders: {
                    ...state.sketchOrders,
                    [action.response.id]: {
                        isFetching: false,
                        ...action.response
                    }
                }
            });
        case GET_SKETCH_ORDER_FAILURE:
        case UPDATE_SKETCH_ORDER_FAILURE:
            return Object.assign({}, state, {
                sketchOrders: {
                    ...state.sketchOrders,
                    [action.params.id]: {
                        ...state.sketchOrders[action.params.id],
                        isFetching: false,
                    }
                }
            });
        default:
            return state;
    }
};

export default sketchOrdersReducer;